import React, { useRef, useState } from "react";
import { Typography, Button } from "@material-ui/core";
import useStyles from "../../../../styles";
import { ReactComponent as ImportIcon } from "../../../images/commonicon/importicon.svg";
import { ReactComponent as ExportIcon } from "../../../images/commonicon/exporticon.svg";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import Loader from "../../../CustomComponent/Loader";

function PageHeader({ questionList, examName, fetchData }) {
  const classes = useStyles();
  const params = useParams();
  const fileInputRef = useRef(null);
  const [importing, setImporting] = useState(false);
  const Token = decryptData(sessionStorage.getItem("token"));

  // console.log("questionList----", questionList);

  const handleImportClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    console.log("file", file);
    if (!file || !params.rowId) {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("exam_id", params.rowId);
    console.log("formData", formData);

    setImporting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/awnserkey/csv/import`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Answer Key Imported Successfully!");
        fetchData();
      } else {
        toast.error(response.data.message || "Import failed.");
      }
    } catch (error) {
      console.error("Import error:", error);
      toast.error(error.response?.data?.message || "Failed to import file.");
    } finally {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setImporting(false);
    }
  };

  const handleDownloadSample = async () => {
    try {
      const response = await axios.get(
        // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/awnserkey/csv/export/sample/:exam_id?exam_id=${params.rowId}`,
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/awnserkey/csv/export/sample`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );

      const downloadUrl = response.data?.download_url;
      console.log("downloadUrl", downloadUrl);
      if (downloadUrl) {
        console.log("downloadUrl1", downloadUrl);
        window.open(downloadUrl, "_blank");

        toast.success("Awnser key sample file Download successfully!");
      } else {
        toast.error("Download URL not found in response.");
      }
    } catch (error) {
      console.error("Download failed:", error);
      toast.error(
        `Failed to download: ${error.response?.data?.message || error.message}`
      );
    }
  };

  const handleDownload = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/awnserkey/csv/export/awnserkey/:exam_id?exam_id=${params.rowId}`,
        // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/awnserkey/csv/import/sample:{exam_id}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );

      const downloadUrl = response.data?.download_url;
      console.log("downloadUrl", downloadUrl);
      if (downloadUrl) {
        console.log("downloadUrl1", downloadUrl);
        window.open(downloadUrl, "_blank");

        toast.success("Awnser key Download successfully!");
      } else {
        toast.error("Download URL not found in response.");
      }
    } catch (error) {
      console.error("Download failed:", error);
      toast.error(
        `Failed to download: ${error.response?.data?.message || error.message}`
      );
    }
  };

  const handleDeleteAnswerKey = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/awnserkey/exam/all/${params.rowId}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );

      if (response.data.success) {
        toast.success("Answer key deleted successfully");
        fetchData();
      }
    } catch (error) {
      console.error("Deletion failed:", error);
      toast.error(
        `Failed to delete answer key: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  return (
    <>
      <Loader loaderOpen={importing} />
      <div className={`${classes.bgwhite} ${classes.boxshadow3}`}>
        <div
          className={`
            ${classes.boxshadow4} 
            ${classes.borderradius6px} 
            ${classes.dflex} 
            ${classes.alignitemscenter} 
            ${classes.justifyspacebetween} 
            ${classes.py0_5} 
            ${classes.px1_5}
          `}
        >
          {/* Left: Heading */}
          <div className={classes.heading}>
            <Typography
              variant="h3"
              className={`
                ${classes.fontsize} 
                ${classes.fontfamilyDMSans} 
                ${classes.fw700}
              `}
            >
              Add Answer
            </Typography>
          </div>

          {/* Right: Buttons */}
          {/* {questionList && ( */}
          <div className={`${classes.dflex} ${classes.gap10}`}>
            {/* Hidden file input */}
            <input
              type="file"
              accept=".csv"
              style={{ display: "none" }}
              ref={fileInputRef}
              onChange={handleFileChange}
            />

            {/* Import Button */}
            <Button
              className={`${classes.custombtnoutline} ${classes.ml1}`}
              startIcon={<ImportIcon />}
              onClick={handleImportClick}
              disabled={importing}
            >
              {importing ? "Importing..." : "Import Answer Key"}
            </Button>
            <Button
              className={`${classes.custombtnblue} ${classes.ml1}`}
              startIcon={<ExportIcon />}
              onClick={handleDownload}
            >
              Export Answer Key
            </Button>
            {/* Download Sample File */}

            <Button
              className={`${classes.custombtnblue} ${classes.ml1}`}
              startIcon={<ExportIcon />}
              onClick={handleDownloadSample}
            >
              Download Sample File
            </Button>
            <Button
              className={`${classes.custombtnblue}`}
              onClick={handleDeleteAnswerKey}
              startIcon={<DeleteOutlineIcon />}
            >
              {/* <DeleteOutlineIcon fontSize="small" style={{marginRight:'2px'}}/>  */}
              Delete Data
            </Button>
          </div>
          {/* )} */}
        </div>
      </div>
    </>
  );
}

export default PageHeader;
